import styles from "./ElinsGridBlock.module.css";

export default function ElinsGridBlock() {
  return <div className={styles.grid} aria-label="ELINS grid" />;
}
